<template>
    <div class="content-wrapper">
        <div class="vld-parent">
            <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
        </div>

        <breadcrumb :page="$t('form.student.studentPreliminaryList')"></breadcrumb>

        <div class="content">
            <div class="container-fluid">
                <b-alert v-model="alert" :variant="alertClass" dismissible fade>{{alertMessage}}</b-alert>

                <b-alert v-model="alertReject" :variant="alertRejectClass" dismissible fade>{{alertRejectMessage}}
                </b-alert>

                <!-- Filters -->
                <div class="card">
                    <div class="card-header bg-light">
                        <h3 class="card-title">{{$t('filters')}}</h3>
                        <div class="text-right">
                            <b-button variant="primary" size="sm" @click="toggleDetailedSearch">{{$t('button.detailedSearch')}}
                            </b-button>
                            <b-button variant="default" size="sm" @click="clearSearch()">{{$t('button.resetFilter')}}
                            </b-button>
                        </div>
                    </div>

                    <div class="card-body">
                        <form role="form">
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>{{$t('form.student.searchCriteria')}}</label>
                                        <v-select @input="loadPreset" label="name" :options="presetList"
                                            v-model="preset"></v-select>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <label>{{$t('form.student.studentName')}}</label>
                                        <input type="text" class="form-control" @keyup="searchStudents"
                                            v-model="search.name" />
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <label>{{$t('form.student.studentNumber')}}</label>
                                        <input type="number" class="form-control" @keyup="searchStudents"
                                            v-model="search.number" />
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <label>{{$t('form.student.status')}}</label>
                                        <v-select @input="searchStudents" label="StatusName" :options="statusList"
                                            v-model="search.Status" :reduce="statusList => statusList.StatusID">
                                        </v-select>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <label>{{$t('form.student.program')}}</label>
                                        <v-select @input="searchStudents" label="FullTitle" :options="programs"
                                            v-model="search.programId" :reduce="programs => programs.ID"></v-select>
                                    </div>
                                </div>
                            </div>

                            <div class="row" v-if="detailedSearch">
                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <label>{{$t('form.student.country')}}</label>
                                        <v-select @input="searchStudents" label="printable_name" :options="countries"
                                            v-model="search.country" :reduce="countries => countries.printable_name">
                                        </v-select>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <label>{{$t('form.student.partnerCode')}}</label>
                                        <v-select label="PartnerCode" :options="partners" v-model="search.partnerId"
                                            @input="partnerFilter" :reduce="partners => partners.PartnerID"></v-select>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <label>{{$t('form.student.title')}}</label>
                                        <v-select @input="searchStudents" :options="titles" v-model="search.title"
                                            :reduce="titles => titles"></v-select>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <label>{{$t('form.student.numberFrom')}}</label>
                                        <input type="text" v-model="search.numberRange.from" @keyup="searchStudents"
                                            class="form-control" />
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <label>{{$t('form.student.numberTo')}}</label>
                                        <input type="text" v-model="search.numberRange.to" @keyup="searchStudents"
                                            class="form-control" />
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <label>{{$t('form.student.firstName')}}</label>
                                        <input type="text" v-model="search.firstName" @keyup="searchStudents"
                                            class="form-control" />
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <label>{{$t('form.student.lastName')}}</label>
                                        <input type="text" v-model="search.lastName" @keyup="searchStudents"
                                            class="form-control" />
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <label>{{$t('form.student.transcriptName')}}</label>
                                        <input type="text" v-model="search.transcriptName" @keyup="searchStudents"
                                            class="form-control" />
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <label>{{$t('form.student.birthDate')}}</label>
                                        <input type="date" v-model="search.birthDate" @change="searchStudents"
                                            class="form-control" />
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <label>{{$t('form.student.birthPlace')}}</label>
                                        <input type="text" v-model="search.birthPlace" @keyup="searchStudents"
                                            class="form-control" />
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <label>{{$t('form.student.birthCountry')}}</label>
                                        <v-select @input="searchStudents" label="printable_name" :options="countries"
                                            v-model="search.birthCountry"
                                            :reduce="countries => countries.printable_name"></v-select>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <label>{{$t('form.student.streetAddress')}}</label>
                                        <input type="text" v-model="search.streetAddress" @keyup="searchStudents"
                                            class="form-control" />
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <label>{{$t('form.student.city')}}</label>
                                        <input type="text" v-model="search.city" @keyup="searchStudents"
                                            class="form-control" />
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <label>{{$t('form.student.postalCode')}}</label>
                                        <input type="text" v-model="search.zip" @keyup="searchStudents"
                                            class="form-control" />
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <label>{{$t('form.student.phone')}}</label>
                                        <input type="text" v-model="search.phone" @keyup="searchStudents"
                                            class="form-control" />
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <label>{{$t('form.student.mobile')}}</label>
                                        <input type="text" v-model="search.mobile" @keyup="searchStudents"
                                            class="form-control" />
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <label>{{$t('form.student.email')}}</label>
                                        <input type="text" v-model="search.email" @keyup="searchStudents"
                                            class="form-control" />
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <label>{{$t('form.student.partnerCampus')}}</label>
                                        <v-select @input="partnerCampusFilter" label="PartnerCampusLocation"
                                            :options="partnercampus" v-model="search.partnerCampus"
                                            :reduce="partnercampus => partnercampus.PartnerCampusID"
                                            :resetOnOptionsChange="true"></v-select>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <label>{{$t('form.student.legalizationOption1')}}</label>
                                        <select class="form-control" v-model="search.legalization"
                                            @change="searchStudents">
                                            <option value selected>{{$t('form.student.select')}}</option>
                                            <option value="1">{{$t('form.student.yes')}}</option>
                                            <option value="0">{{$t('form.student.no')}}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <label>{{$t('form.student.graduationYear')}}</label>
                                        <input type="date" v-model="search.graduate" @change="searchStudents"
                                            class="form-control" />
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>{{$t('form.student.notes')}}</label>
                                        <textarea v-model="search.notes" @keyup="searchStudents" rows="5"
                                            class="form-control"></textarea>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <hr />
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <input type="text" v-model="preset.name" class="form-control"
                                            :placeholder="$t('form.student.presetName')" />
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <button class="btn btn-primary" type="button"
                                        @click="savePreset">{{$t('button.save')}}</button>
                                    <button class="btn btn-danger" type="button" v-show="presetSelected"
                                        @click="deletePreset">{{$t('button.delete')}}</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>

                <!-- Student's List -->
                <div class="card">
                    <div class="card-header bg-light">
                        <div class="d-flex justify-content-between">
                            <div class="card-title">{{$t('form.student.studentPreliminaryList')}} ({{pagination.total}})
                            </div>
                            <div class="d-flex">
                                <div class="text-nowrap mr-1" v-if="students.length">
                                    <b-button variant="success" size="sm" @click="acceptAll()"
                                        v-show="permissions.acceptImportStudents">
                                        {{$t('form.student.accept')}}
                                    </b-button>
                                    <b-button variant="warning" size="sm" @click="rejectAll()"
                                        v-show="permissions.rejectImportStudents">
                                        {{$t('form.student.reject')}}
                                    </b-button>

                                    <!-- <template v-if="downloadToggle">
                                        <button class="btn btn-danger btn-sm" @click="generate('pdf')">
                                            <i class="fa fa-download" aria-hidden="true"></i> {{$t('button.pdf')}}
                                        </button>
                                        <button class="btn btn-success btn-sm" @click="generate('excel')">
                                            <i class="fa fa-download" aria-hidden="true"></i> {{$t('button.excel')}}
                                        </button>
                                        <button class="btn btn-primary btn-sm" @click="generate('word')">
                                            <i class="fa fa-download" aria-hidden="true"></i> {{$t('button.word')}}
                                        </button>
                                    </template> -->
                                </div>

                                <b-form-select style="font-size: 100%"
                                    @change="getStudents();$emit('per-page-updated', perPage)" v-model="perPage"
                                    :options="[25, 50, 100, 500]" size="sm">
                                </b-form-select>
                            </div>
                        </div>
                    </div>

                    <div class="card-body table-responsive p-0">
                        <table class="table table-hover" v-if="students.length">
                            <thead>
                                <tr>
                                    <th>
                                        <input type="checkbox" v-model="selectAll">
                                    </th>

                                    <th>{{$t('form.student.studentNumber')}}</th>

                                    <th>{{$t('form.student.studentName')}}</th>

                                    <th>{{$t('form.student.status')}}</th>

                                    <th>{{$t('form.student.program')}}</th>

                                    <th>{{$t('form.student.country')}}</th>

                                    <th>{{$t('form.student.partnerCode')}}</th>

                                    <th>{{$t('form.student.examScore')}}</th>

                                    <th>{{$t('form.student.applicationDocument')}}</th>

                                    <th class="text-right fix-action">{{$t('form.student.action')}}</th>
                                </tr>
                            </thead>

                            <tbody v-for="(student, index) in students" v-bind:key="index">
                                <tr @dblclick="editStudent(index)"
                                    :class="{'text-danger' : student.ImportFlag === 'rejected'}">
                                    <td>
                                        <input type="checkbox" v-model="student.selected">
                                    </td>
                                    <td>{{student.StudentNumber}}</td>
                                    <td>{{student.FirstName }} {{student.LastName}}</td>
                                    <td>{{student.current_status ? student.current_status.StatusName : ''}}</td>
                                    <td>
                                        <span v-if="student.programs[0]">{{student.programs[0] | program}}</span>
                                    </td>
                                    <td>{{student.Country}}</td>
                                    <td>{{student.partner ? student.partner.PartnerCode : ''}}</td>
                                    <td>
                                        <b-button size="sm" @click="showExamScores(student)">
                                            <span class="fa fa-eye"></span>
                                        </b-button>
                                    </td>
                                    <td>
                                        <b-button size="sm" @click="showApplicationDocs(student)">
                                            <span class="fa fa-eye"></span>
                                        </b-button>
                                        <!-- <span class="fa fa-check text-success"
                                            v-if="isValidApplicationDocuments(student)"></span> -->
                                    </td>
                                    <td class="text-right">
                                        <button class="btn btn-success btn btn-sm" @click="accept(student.ID, index)"
                                            v-show="permissions.acceptImportStudents">
                                            {{$t('form.student.accept')}}
                                        </button>
                                        <button class="btn btn-warning btn btn-sm" @click="reject(student.ID, index)"
                                            v-show="permissions.rejectImportStudents">
                                            {{$t('form.student.reject')}}
                                        </button>
                                        <button class="btn btn-info btn-sm" @click="editStudent(index)"
                                            v-show="permissions.viewStudents">
                                            <span class="fa fa-edit"></span>
                                        </button>
                                        <button class="btn btn-danger btn btn-sm" @click="deletestudent(index)"
                                            v-show="permissions.deleteStudents">
                                            <span class="fa fa-trash"></span>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <p class="p-3 m-0" v-else>{{$t('noRecord')}}</p>
                    </div>

                    <pagination v-if="pagination.last_page > 1" :pagination="pagination" :offset="5"
                        @paginate="paginate()"></pagination>
                </div>

                <b-modal id="examScoreModal" :title="$t('form.student.programScore')">
                    <div class="table-responsive p-0">
                        <table class="table table-bordered">
                            <thead>
                                <tr class="header">
                                    <th>{{$t('form.student.examName')}}</th>
                                    <th>{{$t('form.student.examScore')}}</th>
                                </tr>
                            </thead>

                            <tbody>
                                <tr v-if="examScores.BBAExitSurvey">
                                    <td>{{$t('form.student.bachelorProgramOption1')}}</td>
                                    <td>{{examScores.BBAExitSurveyResult}}</td>
                                </tr>
                                <tr v-if="examScores.MASExitExamSBS">
                                    <td>{{$t('form.student.masterProgramOption2')}}</td>
                                    <td>{{examScores.MASExitExamSBSResult}}</td>
                                </tr>
                                <tr v-if="examScores.MASExitExamExternal">
                                    <td>{{$t('form.student.masterProgramOption3')}}</td>
                                    <td>{{examScores.MASExitExamExternalResult}}</td>
                                </tr>
                                <tr v-if="examScores.DBAExitExamSBS">
                                    <td>{{$t('form.student.doctorateProgramOption2')}}</td>
                                    <td>{{examScores.DBAExitExamSBSResult}}</td>
                                </tr>
                                <tr v-if="examScores.DBAExitExamExternal">
                                    <td>{{$t('form.student.doctorateProgramOption3')}}</td>
                                    <td>{{examScores.DBAExitExamExternalResult}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </b-modal>

                <b-modal id="updateStatusModal" :title="$t('form.student.preliminaryModalTitle')" @show="resetModal"
                    @hidden="resetModal" @ok="handleOk">

                    <form ref="form" @submit.stop.prevent="handleSubmit">

                        <b-form-group :label="$t('form.student.note')" :state="noteState"
                            :invalid-feedback="$t('form.validation.required')">
                            <b-form-input v-model="note" :state="noteState" required>
                            </b-form-input>
                        </b-form-group>

                        <template v-if="action == 'accept'">
                            <b-form-group :label="$t('form.student.status')" :state="statusState"
                                :invalid-feedback="$t('form.validation.required')">
                                <v-select v-model="status" label="StatusName" :options="statuses" :state="statusState"
                                    required>
                                </v-select>
                            </b-form-group>

                            <b-form-group :label="$t('form.student.programStart')" :state="dateState"
                                :invalid-feedback="$t('form.validation.required')">
                                <date-picker :lang="lang" class="date-picker" v-model="date" valueType="format" :format="dateFormat"
                                    :popup-style="{ top: '100%', left: 0}" :append-to-body="false">
                                </date-picker>
                            </b-form-group>
                        </template>
                    </form>
                </b-modal>

                <b-modal id="applicationModal" :title="$t('form.student.applicationDocument')" size="lg">
                    <div class="table-responsive p-0">
                        <table class="table table-bordered">
                            <thead>
                                <tr>
                                    <th>{{$t('form.student.sr')}}</th>
                                    <th>{{$t('form.student.reason')}}</th>
                                    <th>{{$t('form.student.file')}}</th>
                                    <th></th>
                                </tr>
                            </thead>

                            <tbody v-if="selectedProgramCode == 'BBA'">
                                <tr>
                                    <td>1</td>
                                    <td>{{$t('form.student.completeCurriculumVitae')}}</td>
                                    <td>
                                        <ul class="p-0 mt-2">
                                            <li v-for="(file, index) in studentApplication.CurriculumVitae" :key="index"
                                                class="d-flex justify-content-between">
                                                <a href="#" @click.prevent="downloadApplication(file)">{{file}}</a>
                                            </li>
                                        </ul>
                                    </td>
                                    <td>
                                        <input v-model="studentApplication.ValidCurriculumVitae" type="checkbox">
                                    </td>
                                </tr>

                                <tr>
                                    <td>2</td>
                                    <td>{{$t('form.student.certifiedCopyHighSchool')}}</td>
                                    <td>
                                        <ul class="p-0 mt-2">
                                            <li v-for="(file, index) in studentApplication.Degree" :key="index"
                                                class="d-flex justify-content-between">
                                                <a href="#" @click.prevent="downloadApplication(file)">{{file}}</a>
                                            </li>
                                        </ul>
                                    </td>
                                    <td>
                                        <input v-model="studentApplication.ValidDegree" type="checkbox">
                                    </td>
                                </tr>

                                <tr>
                                    <td>3</td>
                                    <td>{{$t('form.student.officialAcademicTranscripts')}}</td>
                                    <td>
                                        <ul class="p-0 mt-2">
                                            <li v-for="(file, index) in studentApplication.Transcript" :key="index"
                                                class="d-flex justify-content-between">
                                                <a href="#" @click.prevent="downloadApplication(file)">{{file}}</a>
                                            </li>
                                        </ul>
                                    </td>
                                    <td>
                                        <input v-model="studentApplication.ValidTranscript" type="checkbox">
                                    </td>
                                </tr>

                                <tr>
                                    <td>4</td>
                                    <td>{{$t('form.student.motivationLetter')}}
                                    <td>
                                        <ul class="p-0 mt-2">
                                            <li v-for="(file, index) in studentApplication.Letter" :key="index"
                                                class="d-flex justify-content-between">
                                                <a href="#" @click.prevent="downloadApplication(file)">{{file}}</a>
                                            </li>
                                        </ul>
                                    </td>
                                    <td>
                                        <input v-model="studentApplication.ValidLetter" type="checkbox">
                                    </td>
                                </tr>

                                <tr>
                                    <td>5</td>
                                    <td>{{$t('form.student.aSatScore')}}</td>
                                    <td>{{studentApplication.Score}}</td>
                                    <td></td>
                                </tr>

                                <tr>
                                    <td>6</td>
                                    <td>{{$t('form.student.englishProficiency')}}</td>

                                    <td>
                                        <ul class="p-0 mt-2">
                                            <li v-for="(file, index) in studentApplication.EnglishProficiency"
                                                :key="index" class="d-flex justify-content-between">
                                                <a href="#" @click.prevent="downloadApplication(file)">{{file}}</a>
                                            </li>
                                        </ul>
                                    </td>
                                    <td>
                                        <input v-model="studentApplication.ValidEnglishProficiency" type="checkbox">
                                    </td>
                                </tr>

                                <tr>
                                    <td>7</td>
                                    <td>{{$t('form.student.onePicture')}}</td>
                                    <td>
                                        <ul class="p-0 mt-2">
                                            <li v-for="(file, index) in studentApplication.Picture" :key="index"
                                                class="d-flex justify-content-between">
                                                <a href="#" @click.prevent="downloadApplication(file)">{{file}}</a>
                                            </li>
                                        </ul>
                                    </td>
                                    <td>
                                        <input v-model="studentApplication.ValidPicture" type="checkbox">
                                    </td>
                                </tr>
                            </tbody>

                            <tbody v-if="selectedProgramCode == 'MSc' || selectedProgramCode == 'MBA'">
                                <tr>
                                    <td>1</td>
                                    <td>{{$t('form.student.completeCurriculumVitae')}}</td>
                                    <td>
                                        <ul class="p-0 mt-2">
                                            <li v-for="(file, index) in studentApplication.CurriculumVitae" :key="index"
                                                class="d-flex justify-content-between">
                                                <a href="#" @click.prevent="downloadApplication(file)">{{file}}</a>
                                            </li>
                                        </ul>
                                    </td>
                                    <td>
                                        <input v-model="studentApplication.ValidCurriculumVitae" type="checkbox">
                                    </td>
                                </tr>

                                <tr>
                                    <td>2</td>
                                    <td>{{$t('form.student.certifiedCopyBachelor')}}</td>
                                    <td>
                                        <ul class="p-0 mt-2">
                                            <li v-for="(file, index) in studentApplication.Degree" :key="index"
                                                class="d-flex justify-content-between">
                                                <a href="#" @click.prevent="downloadApplication(file)">{{file}}</a>
                                            </li>
                                        </ul>
                                    </td>
                                    <td>
                                        <input v-model="studentApplication.ValidDegree" type="checkbox">
                                    </td>
                                </tr>

                                <tr>
                                    <td>3</td>
                                    <td>{{$t('form.student.officialAcademicTranscripts')}}</td>
                                    <td>
                                        <ul class="p-0 mt-2">
                                            <li v-for="(file, index) in studentApplication.Transcript" :key="index"
                                                class="d-flex justify-content-between">
                                                <a href="#" @click.prevent="downloadApplication(file)">{{file}}</a>
                                            </li>
                                        </ul>
                                    </td>
                                    <td>
                                        <input v-model="studentApplication.ValidTranscript" type="checkbox">
                                    </td>
                                </tr>

                                <tr>
                                    <td>4</td>
                                    <td>{{$t('form.student.twoReferenceLetters')}}</td>
                                    <td>
                                        <ul class="p-0 mt-2">
                                            <li v-for="(file, index) in studentApplication.Letter" :key="index"
                                                class="d-flex justify-content-between">
                                                <a href="#" @click.prevent="downloadApplication(file)">{{file}}</a>
                                            </li>
                                        </ul>
                                    </td>
                                    <td>
                                        <input v-model="studentApplication.ValidLetter" type="checkbox">
                                    </td>
                                </tr>

                                <tr>
                                    <td>5</td>
                                    <td>{{$t('form.student.onePicture')}}</td>
                                    <td>
                                        <ul class="p-0 mt-2">
                                            <li v-for="(file, index) in studentApplication.Picture" :key="index"
                                                class="d-flex justify-content-between">
                                                <a href="#" @click.prevent="downloadApplication(file)">{{file}}</a>
                                            </li>
                                        </ul>
                                    </td>
                                    <td>
                                        <input v-model="studentApplication.ValidPicture" type="checkbox">
                                    </td>
                                </tr>
                            </tbody>

                            <tbody v-if="selectedProgramCode == 'DBA'">
                                <tr>
                                    <td>1</td>
                                    <td>{{$t('form.student.completeCurriculumVitae')}}</td>
                                    <td>
                                        <ul class="p-0 mt-2">
                                            <li v-for="(file, index) in studentApplication.CurriculumVitae" :key="index"
                                                class="d-flex justify-content-between">
                                                <a href="#" @click.prevent="downloadApplication(file)">{{file}}</a>
                                            </li>
                                        </ul>
                                    </td>
                                    <td>
                                        <input v-model="studentApplication.ValidCurriculumVitae" type="checkbox">
                                    </td>
                                </tr>

                                <tr>
                                    <td>2</td>
                                    <td>{{$t('form.student.certifiedCopyMaster')}}</td>
                                    <td>
                                        <ul class="p-0 mt-2">
                                            <li v-for="(file, index) in studentApplication.Degree" :key="index"
                                                class="d-flex justify-content-between">
                                                <a href="#" @click.prevent="downloadApplication(file)">{{file}}</a>
                                            </li>
                                        </ul>
                                    </td>
                                    <td>
                                        <input v-model="studentApplication.ValidDegree" type="checkbox">
                                    </td>
                                </tr>

                                <tr>
                                    <td>3</td>
                                    <td>{{$t('form.student.officialAcademicTranscripts')}}</td>
                                    <td>
                                        <ul class="p-0 mt-2">
                                            <li v-for="(file, index) in studentApplication.Transcript" :key="index"
                                                class="d-flex justify-content-between">
                                                <a href="#" @click.prevent="downloadApplication(file)">{{file}}</a>
                                            </li>
                                        </ul>
                                    </td>
                                    <td>
                                        <input v-model="studentApplication.ValidTranscript" type="checkbox">
                                    </td>
                                </tr>

                                <tr>
                                    <td>4</td>
                                    <td>{{$t('form.student.employmentConfirmationLetter')}}</td>
                                    <td>
                                        <ul class="p-0 mt-2">
                                            <li v-for="(file, index) in studentApplication.Letter" :key="index"
                                                class="d-flex justify-content-between">
                                                <a href="#" @click.prevent="downloadApplication(file)">{{file}}</a>
                                            </li>
                                        </ul>
                                    </td>
                                    <td>
                                        <input v-model="studentApplication.ValidLetter" type="checkbox">
                                    </td>
                                </tr>

                                <tr>
                                    <td>5</td>
                                    <td>{{$t('form.student.onePicture')}}</td>
                                    <td>
                                        <ul class="p-0 mt-2">
                                            <li v-for="(file, index) in studentApplication.Picture" :key="index"
                                                class="d-flex justify-content-between">
                                                <a href="#" @click.prevent="downloadApplication(file)">{{file}}</a>
                                            </li>
                                        </ul>
                                    </td>
                                    <td>
                                        <input v-model="studentApplication.ValidPicture" type="checkbox">
                                    </td>
                                </tr>

                                <tr>
                                    <td>6</td>
                                    <td>{{$t('form.student.researchInterestOutline')}}</td>
                                    <td>{{studentApplication.ResearchInterestOutline}}</td>
                                    <td></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </b-modal>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: ['permissions', 'dateFormat', 'user'],

        data() {
            return {

                fullPage: true,
                isLoading: false,

                detailedSearch: false,
                // downloadToggle: false,
                perPage: this.user.per_page,

                alert: false,
                alertClass: '',
                alertMessage: '',

                alertReject: false,
                alertRejectClass: '',
                alertRejectMessage: '',

                presetSelected: false,
                request_source: '',
                selectAll: false,
                note: null,
                noteState: null,
                date: null,
                dateState: null,
                action: null,
                status: null,
                statusState: null,

                lang: {
                    formatLocale: {
                        firstDayOfWeek: 1,
                    },
                },                

                preset: {
                    name: '',
                    entity: 'student',
                    value: {}
                },

                search: {
                    title: '',
                    status: '',
                    country: '',
                    programId: '',
                    partnerId: '',
                    birthCountry: '',
                    partnerCampus: '',
                    graduate: '',
                    legalization: '',
                    numberRange: {}
                },

                pagination: {
                    current_page: 1
                },

                students: [],
                partnercampus: [],
                statusList: [],
                programs: [],
                countries: [],
                partners: [],
                titles: [],
                presetList: [],
                examScores: {},
                statuses: [],
                studentApplication: {},
                selectedProgramCode: null,
            }
        },

        mounted() {
            if (!this.permissions.viewStudentsImported) {
                this.$router.push('/');
                return;
            }

            this.getStudents();
            this.getFillterList();
            this.getPresets();
            this.getStatuses();
        },

        watch: {
            selectAll(val) {
                this.students.map(s => s.selected = val);
            },
            search: {
                handler(newSearch) {
                    const emojiRegex = /[\u{10000}-\u{10FFFF}]/gu;
                    
                    // Loop through all properties in the search object
                    Object.keys(newSearch).forEach(key => {
                    // Only process string values
                    if (typeof newSearch[key] === 'string' && emojiRegex.test(newSearch[key])) {
                        // Strip the emoji and update the reactive property
                        this.search[key] = newSearch[key].replace(emojiRegex, '');
                    }
                    });
                },
                deep: true  
            }
        },

        methods: {

            async createToken(type) {
                let response = await axios.post('/api/api-tokens', {
                    type
                });
                let token = '';

                if (response.status == 200) {
                    token = response.data.extra[0].token
                }

                return token;
            },

            async downloadApplication(file) {
                let token = await this.createToken('student-application');

                if (token == '') return;

                window.open(`/students/applications?file=${file}&token=${token}`, '_blank');
            },

            checkFormValidity() {
                let valid = this.$refs.form.checkValidity()

                this.noteState = valid
                this.dateState = true;
                this.statusState = true

                if (!this.date && this.action == 'accept') {
                    this.dateState = false;
                    valid = false;
                }

                if (!this.status && this.action == 'accept') {
                    this.statusState = false;
                    valid = false;
                }

                return valid
            },

            resetModal() {
                this.note = ''
                this.date = null
                this.status = null
                this.noteState = null
                this.dateState = null
                this.statusState = null
            },

            handleOk(bvModalEvt) {
                // Prevent modal from closing
                bvModalEvt.preventDefault()
                // Trigger submit handler
                this.handleSubmit()
            },

            handleSubmit() {
                // Exit when the form isn't valid
                if (!this.checkFormValidity()) {
                    return
                }

                // Update status call
                this.updateStatus();
            },

            /**
             * Accept Imported Student
             */
            accept(id, index) {
                this.action = 'accept'
                this.students[index].selected = true;
                this.$bvModal.show('updateStatusModal')
            },

            acceptAll() {
                this.action = 'accept'

                // check if none student selected
                let found = this.students.find(s => s.selected == true)

                if (!found) {
                    alert(this.$t('form.validation.noneSelected'))
                    return
                }

                this.$bvModal.show('updateStatusModal')
            },

            /**
             * Reject Imported Student
             */
            reject(id, index) {
                this.action = 'reject'
                this.students[index].selected = true;
                this.$bvModal.show('updateStatusModal')
            },

            rejectAll() {
                this.action = 'reject'

                // check if none student selected
                let found = this.students.find(s => s.selected == true)

                if (!found) {
                    alert(this.$t('form.validation.noneSelected'))
                    return
                }

                this.$bvModal.show('updateStatusModal')
            },

            /**
             * Update imported student status
             */
            updateStatus() {
                let data = {
                    note: this.note,
                    date: this.date,
                    status_id: this.status ? this.status.StatusID : null,
                    students: []
                };

                this.students.forEach(s => {
                    if (s.selected) data.students.push(s.ID)
                })

                this.isLoading = true;

                axios
                    .put(`/api/students/${this.action}`, data)
                    .then(response => {
                        this.isLoading = false;
                        this.selectAll = false

                        this.$nextTick(() => this.$bvModal.hide('updateStatusModal'))

                        if (data.students.length != response.data.data.length) {
                            this.showAlert('info', response.data.message);
                        }

                        // rejection found check
                        if (response.data.data.length > 0) {
                            this.showRejectAlert('danger', this.$t('form.validation.rejectionFoundFor', {
                                ids: response.data.data.join(',')
                            }))
                        }

                        this.getStudents();
                    }).catch(error => {
                        console.log('error updating status')
                        this.isLoading = false;
                    });
            },

            isValidApplicationDocuments(student) {

                let application = student.application;
                let program = student.programs[0] ? student.programs[0] : null;

                if (application && program) {
                    // BBA
                    if (program.ProgramCode == 'BBA') {
                        return (application.ValidCurriculumVitae &&
                            application.ValidDegree &&
                            application.ValidTranscript &&
                            application.ValidLetter &&
                            application.ValidPicture &&
                            application.ValidPassportCopy &&
                            application.ValidPermitCopy&&
                            application.ValidEnglishProficiency);
                    }

                    // MSc & MBA & DBA
                    return (application.ValidCurriculumVitae &&
                        application.ValidDegree &&
                        application.ValidTranscript &&
                        application.ValidLetter &&
                        application.ValidPicture &&
                        application.ValidPassportCopy &&
                        application.ValidPermitCopy);
                }

                return false;
            },

            /**
             * Build Query String for Filters
             */
            buildQueryString(obj) {
                let query = '';

                Object.keys(obj).forEach(function (key) {
                    if (key == "numberRange" && obj[key].from && obj[key].to) {
                        query += key + "=" + encodeURIComponent(obj[key].from) + "," + encodeURIComponent(obj[key].to) + "&";
                    }
                    else if (obj[key] != "" && key != "numberRange" && obj[key] != null) {
                        query += key + "=" + encodeURIComponent(obj[key]) + "&";
                    }
                });

                return query.slice(0, -1);
            },

            /**
             * Export students list - PDF | Excel | Word
             */
            // async generate(method) {
            //     let filters = await this.buildQueryString(this.search);

            //     window.open(
            //         `${window.location.origin}/students/export?method=${method}&${filters}&preliminaryList=1`,
            //         "_blank");
            // },

            /**
             * Save Preset into database
             */
            savePreset() {
                this.isLoading = true;
                this.alert = false;

                this.preset.value = JSON.stringify(this.search);

                axios
                    .post('/api/presets', this.preset)
                    .then(response => {
                        this.isLoading = false;
                        this.showAlert('success', response.data.message);
                        this.getPresets();
                    }, error => {
                        this.isLoading = false;

                        if (error.response.status == 422)
                            this.showAlert('danger', error.response.data.errors.name[0]);
                    })
                    .catch(errors => console.log(errors.response));
            },

            /**
             * Get Preset List
             */
            getPresets() {
                axios
                    .get('/api/presets/?entity=' + this.preset.entity)
                    .then(response => {
                        this.presetList = response.data;
                    }, error => {
                        console.log(error.response);
                    });
            },

            /**
             * Load Preset and apply Filters
             */
            loadPreset() {
                if (!this.preset) {
                    this.preset = {
                        entity: 'student'
                    };
                    this.clearSearch();
                    this.alert = false;
                    this.presetSelected = false;
                    return;
                }
                this.alert = false;
                this.presetSelected = true;
                this.search = JSON.parse(this.preset.value);
                this.searchStudents();
            },

            /**
             * Delete the specific preset
             */
            deletePreset() {

                if (!confirm(this.$t('form.validation.delete'))) {
                    return;
                }

                axios
                    .delete("/api/presets/" + this.preset.id)
                    .then(response => {
                        if (response.data.status == 'success') {
                            this.showAlert('success', response.data.message);
                            this.getPresets();
                            this.clearSearch();
                            this.preset.name = '';
                            this.preset.value = {};
                            this.presetSelected = false;
                        }
                    })
                    .catch(error => {
                        this.isLoading = false;
                    });
            },

            /**
             * Reset applied filters
             */
            clearSearch() {
                this.search = {
                    title: '',
                    status: '',
                    country: '',
                    programId: '',
                    partnerId: '',
                    birthCountry: '',
                    partnerCampus: '',
                    graduate: '',
                    legalization: '',
                    numberRange: {}
                };

                this.searchStudents();
            },

            /**
             * Get Partner Campuses against Partner
             */
            fetchPartnerCampus() {
                axios
                    .get(`/api/campuses?full&PartnerID=${this.search.partnerId}`)
                    .then(response => this.partnercampus = response.data)
                    .catch(error => console.log('error fetching partner campuses'));
            },

            // Toggle detail search
            toggleDetailedSearch() {
                this.detailedSearch = !this.detailedSearch;
            },

            /**
             * Get student list
             */
            getStudents() {
                let source = axios.CancelToken.source();

                if (this.request_source != '') {
                    this.request_source.cancel('Operation canceled by the user.');
                    console.clear();
                }

                this.request_source = source;

                this.isLoading = true;

                let filters = this.buildQueryString(this.search);

                if (filters != '')
                    filters = '&' + filters;

                // if (filters == '')
                //     this.downloadToggle = false;

                filters += '&preliminaryList=1';

                if (this.perPage) filters += `&limit=${this.perPage}`

                axios
                    .get(`/api/students?page=${this.pagination.current_page}${filters}`, {
                        cancelToken: this.request_source.token
                    })
                    .then(response => {
                        this.students = response.data.data.data;
                        this.pagination = response.data.pagination;

                        if (this.search.partnerId && !this.search.partnerCampus) {
                            this.fetchPartnerCampus();
                        }

                        this.isLoading = false;
                    })
                    .catch(error => console.log(error));
            },

            /**
             * Apply paginate
             */
            paginate() {
                this.getStudents();
            },

            /**
             * Apply filters
             */
            searchStudents() {
                // if (this.pagination.total > 0) {
                //     this.downloadToggle = true;
                // }

                this.pagination.current_page = 1;

                this.getStudents();
            },

            /**
             * Check if partner campus set then apply filters
             */
            partnerCampusFilter() {
                if (!this.search.partnerCampus) {
                    return;
                }

                this.searchStudents();
            },

            /**
             * Apply partner filter and reset partner campus filter
             */
            partnerFilter() {
                this.search.partnerCampus = null;
                this.partnercampus = [];

                this.searchStudents();
            },

            /**
             * Get Filter List
             */
            getFillterList() {
                axios
                    .get("/api/students/initial-data")
                    .then(response => {
                        let data = response.data;

                        this.statusList = data.status;
                        this.partners = data.partners;
                        this.countries = data.countries;
                        this.titles = data.titles;

                        this.programs = data.programs;
                        this.programs.map(p => p.FullTitle = this.$options.filters.program(p));
                    })
                    .catch(error => console.log(error));
            },

            /**
             * Get Statuses - Enrolled & Conditional Acceptance
             */
            getStatuses() {
                axios
                    .get("/api/statuses?preliminary_list")
                    .then(response => {
                        this.statuses = response.data;
                    })
                    .catch(error => console.log('error fetching statuses'));
            },

            /**
             * Go to student edit page
             */
            editStudent(index) {
                if (!this.permissions.viewStudents) return;

                let id = this.students[index].StudentNumber;

                this.$router.push({
                    name: "StudentEdit",

                    params: {
                        id: id
                    }
                });
            },

            /**
             * Show alert
             */
            showAlert(alertClass, alertMessage) {
                this.alertClass = alertClass;
                this.alertMessage = alertMessage;
                this.alert = true;
            },

            /**
             * Show alert
             */
            showRejectAlert(alertClass, alertMessage) {
                this.alertRejectClass = alertClass;
                this.alertRejectMessage = alertMessage;
                this.alertReject = true;
            },

            /**
             * Delete student
             */
            deletestudent(index) {
                let conf = confirm(this.$t('form.validation.delete'));

                if (conf === true) {
                    this.isLoading = true;
                    axios
                        .delete("/api/students/" + this.students[index].ID)
                        .then(response => {
                            this.isLoading = false;
                            this.students.splice(index, 1);
                            this.showAlert('success', response.data.message);
                            this.getStudents();
                        })
                        .catch(error => {
                            this.isLoading = false;
                        });
                }
            },

            // Get Exam Score
            showExamScores(Student) {
                this.examScores = Student.graduatereq ? Student.graduatereq : {};
                this.$bvModal.show('examScoreModal');
            },

            // Get Exam Score
            showApplicationDocs(Student) {
                this.selectedProgramCode = Student.programs.length ? Student.programs[0].ProgramCode : null;
                this.studentApplication = Student.application ? Student.application : {};
                this.$bvModal.show('applicationModal');
            }

        }
    };

</script>
